
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: ''
})
export default class DefaultScreenContent extends Vue {
  @Prop({ required: false, default: 0 })
  private triggerReload: number;

  private internIriggerReload  = 0;

  @Watch('triggerReload')
  private triggerReloadOnChange() {
    this.reload();
  }

  public reload() {
    this.internIriggerReload++;
  }
}
